import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

/**
 * Thin wrapper around Capacitor's Preferences API. Preferences writes to native
 * persistent storage (UserDefaults on iOS, SharedPreferences on Android), so
 * values survive the app being killed AND user logout — they are only cleared
 * when the app is uninstalled. Use this (rather than StorageService, which is
 * file-based and wiped on logout via clear()) for install-scoped flags such as
 * one-time consent/disclosure acknowledgements.
 */
@Injectable({
  providedIn: 'root',
})
export class PreferencesService {
  async set(key: string, value: string): Promise<void> {
    await Preferences.set({ key, value });
  }

  async get(key: string): Promise<string | null> {
    const { value } = await Preferences.get({ key });

    return value;
  }

  async remove(key: string): Promise<void> {
    await Preferences.remove({ key });
  }
}
